@if (dataLoaded) {
  <div class="tea-create-pickup">
    <div class="steps">
      <div class="list-steps">
        <app-steps [steps]="formActivityPickupService.steps" [currentStep]="1"></app-steps>
      </div>
    </div>
    <div class="form-group space-input step-2">
      <div class="form-filter">
        <div class="label-title step2-title">
          <label class="label">公開先スペース</label>
        </div>
        @if (formActivityPickupService.space) {
          <div class="space-info-confirm">
            <div class="block-color" [style.background-color]="formActivityPickupService.space.color_code"></div>
            <span class="truncate-text">{{ formActivityPickupService.space.name }}</span>
          </div>
        } @else {
          <div class="space-content">
            @for (space of formActivityPickupService.spaces; track space.id) {
              <div class="space">
                @if (!layoutService.isTabletDownView.value) {
                  <div class="block-color" [style.background-color]="space.color_code"></div>
                }
                <p class="truncate-text">{{ space.name }}</p>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="form-group form-input step-2">
      <div class="form-filter">
        <div class="label-title">
          <label class="label">ピックアップ表示期間</label>
        </div>
        <div class="form-filter">
          <p>{{ formatedDates() }}</p>
        </div>
      </div>
    </div>
    <div class="form-group form-input input-radio">
      <div class="form-filter">
        <div class="label-title">
          <label class="label">匿名設定</label>
        </div>
        <div class="form-filter">
          @if (!formActivityPickupService.activityPickup.is_anonymous) {
            <p>匿名にしない</p>
          } @else {
            <div class="form-filter">
              <p>匿名にする</p>
            </div>
            <div class="form-filter margin-note">
              <p>※生徒が自主公開している場合は匿名になりません</p>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="block-standard">
      <div class="form-filter">
        <div class="label-title">
          <label class="label">説明</label>
        </div>
        <div class="label-title step-2">
          <p class="preserve-line-break">{{ enteredReason ? formActivityPickupService.activityPickup.reason : '未入力' }}</p>
        </div>
      </div>
    </div>
    <div class="list-button-submit">
      <button type="button" class="spen-mod-btn" (click)="goBack()" [disabled]="isSavingPickup">戻る</button>
      <button type="button" class="spen-mod-btn is-primary" (click)="onSubmit()" [disabled]="isSavingPickup">
        {{ isEditPickup() ? '変更完了' : '設定完了' }}
      </button>
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
